import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallText from '../../../common-components/common-small-text';

const Ciphers = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper bigPaddings={true} className="nanoteh-ciphers">
                <div className="nanoteh-ciphers__wrapper">
                    <CommonTitle className="nanoteh-ciphers__title">Цифры</CommonTitle>
                    <div className="nanoteh-ciphers__data-container">
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={0}
                            delay={100}
                            animateOnce={true}
                            duration={1}
                            className="nanoteh-ciphers__data-item"
                        >
                            <div className="nanoteh-ciphers__data-title">120</div>
                            <CommonSmallText className="nanoteh-ciphers__data-subtitle">
                                часов работы команды
                            </CommonSmallText>
                            <img
                                src="/images/svg/nanotech/anoteh-ciphers__data-img.svg"
                                alt=""
                                className="nanoteh-ciphers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={0}
                            delay={200}
                            animateOnce={true}
                            duration={1}
                            className="nanoteh-ciphers__data-item"
                        >
                            <div className="nanoteh-ciphers__data-title">6</div>
                            <CommonSmallText className="nanoteh-ciphers__data-subtitle">
                                месяцев работы
                            </CommonSmallText>
                            <img
                                src="/images/svg/nanotech/anoteh-ciphers__data-img.svg"
                                alt=""
                                className="nanoteh-ciphers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={0}
                            delay={300}
                            animateOnce={true}
                            duration={1}
                            className="nanoteh-ciphers__data-item"
                        >
                            <div className="nanoteh-ciphers__data-title">90</div>
                            <CommonSmallText className="nanoteh-ciphers__data-subtitle">
                                поисковых запросов
                            </CommonSmallText>
                            <img
                                src="/images/svg/nanotech/anoteh-ciphers__data-img.svg"
                                alt=""
                                className="nanoteh-ciphers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={0}
                            delay={400}
                            animateOnce={true}
                            duration={1}
                            className="nanoteh-ciphers__data-item"
                        >
                            <div className="nanoteh-ciphers__data-title">11</div>
                            <CommonSmallText className="nanoteh-ciphers__data-subtitle">
                                городов-миллионников
                            </CommonSmallText>
                            <img
                                src="/images/svg/nanotech/anoteh-ciphers__data-img.svg"
                                alt=""
                                className="nanoteh-ciphers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Ciphers;
